import { create } from 'zustand';

import { _system } from '~/Services/Studio/studioScene';
import { ContentModel } from '~/Scene/Content/contentModel';

interface IModelContext {
    model: ContentModel,
    setModel: (model: ContentModel) => void,
}

export const useModelState = create<IModelContext>((set, get) => ({
    model: null,
    setModel: (
        model: ContentModel,
    ) => set(() => ({ model })),
}));
